import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { VWProgram } from '@app/core/models';
import { AppState, selectProgram } from '@app/core/ngrx';

@Component({
  selector: 'ecp-return-submit-confirm',
  templateUrl: './return-submit-confirm.component.html',
  styleUrls: ['./return-submit-confirm.component.scss'],
})
export class ReturnSubmitConfirmComponent {
  public program$: Observable<VWProgram>;
  theme = 'one-portal';

  constructor(
    public dialogRef: MatDialogRef<ReturnSubmitConfirmComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.program$ = this.store.pipe(select(selectProgram));
    this.program$.pipe().subscribe(program => {
      if (program) {
        this.theme = program.programKey;
      }
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog(isApply): void {
    this.dialogRef.close(isApply);
  }
}
